<template>
  <div class="content ht-100v pd-0">
    <report-dialog
      v-if="reportDialog.id > 0"
      :id.sync="reportDialog.id"
      :obj.sync="reportDialog.obj"
      @on-repord-loaded="reportLoaded"
      @on-report-close="
        reportDialog.id = 0;
        reportLoaded();
      "
    ></report-dialog>

    <project-users
      :show="projectEdit.show"
      :obj.sync="project"
      module="project"
      @on-edit-close="projectUsersClosed"
      @on-share="showMention"
    ></project-users>
    <mention-users
      :show="projectMention.show"
      :obj.sync="project"
      module="project"
      @on-mention-close="projectMention.show = false"
    ></mention-users>

    <div ref="mainHeader" class="content-header bd-b pd-0">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
        <a
          class="navbar-brand tx-bold tx-spacing--2 order-1"
          data-toggle="dropdown"
          role="button"
        >
          <a
            class="btn- btn-info btn-uppercase pd-x-15 pd-t-10 pd-b-8 text-white mg-r-10 rounded-sm"
          >
            <feather type="layers" class="wd-15 ht-15 mg-r-5"></feather>цэс
          </a>
          Тайлан
          <feather type="chevron-down" class="wd-15 ht-15"></feather>
        </a>
        <div class="dropdown-menu tx-13">
          <!-- <a href="javascript:void(0)" class="dropdown-item">Загвар</a> -->
          <a
            @click="showMention()"
            href="javascript:void(0)"
            class="dropdown-item"
            >Хуваалцах</a
          >
          <a
            @click="projectUsers()"
            href="javascript:void(0)"
            class="dropdown-item"
            >Эрхийн тохиргоо</a
          >
        </div>
      </nav>
    </div>
    <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
      <div class="container-fluid pd-x-0" id="cstmScrll">
        <div class="row no-gutters">
          <div class="col-xs-2 col-md-2 bg-white">
            <div class="pd-t-20 pd-b-10 pd-x-10">
              <label
                class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
                >Тайлан мэдээ</label
              >
              <Tree
                ref="folterTree"
                node-key="id"
                node-key1="label"
                :data="folders"
                :props="defaultProps"
                @node-click="categoryChange"
                auto-expand-parent
                accordion
                :expand-on-click-node="true"
                highlight-current
                :current-node-key="$route.params.cid"
                :default-expanded-keys="expandKeys"
                :filter-node-method="filterNode"
                :key="treeKey"
                class="manual-tree"
              >
              </Tree>
            </div>
          </div>
          <div
            class="col-xs-10 col-md-10 bd-l"
            style="height: calc(100vh - 60px); overflow: auto !important"
          >
            <div v-if="!loading" class="row row-xs pd-20">
              <div v-if="tasksCount == 0" class>
                <div class>
                  <div
                    class="ht-700 d-flex flex-column align-items-center justify-content-center"
                  >
                    <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                      <img src="assets/img/img22.png" class="img-fluid" alt />
                    </div>
                    <p class="tx-color-03 mg-b-30">Жагсаалт хоосон байна.</p>
                  </div>
                </div>
              </div>
              <template v-else v-for="(t, i) in tasks">
                <div
                  :key="i"
                  @click="showReport(t)"
                  class="col-sm-4 col-md-2"
                  role="button"
                >
                  <div class="card card-file">
                    <div class="card-file-thumb tx-success">
                      <i class="far fa-file"></i>
                    </div>
                    <div class="card-body">
                      <div
                        v-if="
                          downloadedRdy &&
                            downloadedReports.filter(
                              x =>
                                x.mainReportId == t.id && x.version < t.version
                            ).length
                        "
                        class="marker marker-ribbon marker-warning marker-top-right pos-absolute t-10 r-0"
                      >
                        Шинэчлэлт татах
                      </div>
                      <div
                        v-else-if="
                          downloadedRdy &&
                            downloadedReports.filter(
                              x => x.mainReportId == t.id
                            ).length == 0
                        "
                        class="marker marker-ribbon marker-success marker-top-right pos-absolute t-10 r-0"
                      >
                        татах
                      </div>
                      <h6>
                        <a :title="t.task" class="link-02">{{ t.task }}</a>
                      </h6>
                      <span>{{ t.locTypeName }}</span>
                    </div>
                    <div class="card-footer">
                      <span class="d-none d-sm-inline">Тайлбар:</span>
                      {{ t.taskEn }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-else></div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="store.modal" title="Тайлан" size="lg" scrollable>
      <div>
        <h5>{{ store.task.task }}</h5>
        <div class="mg-b-10 bd-l bd-5 pd-l-10 bg-gray-100 pd-y-10">
          {{ store.task.taskEn }}
        </div>
        <img :src="store.task.defaultAttachmentUrl" class="wd-100p" />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <p class="float-left"></p>
          <b-button
            v-if="
              downloadedRdy &&
                downloadedReports.filter(
                  x =>
                    x.mainReportId == store.task.id &&
                    x.version < store.task.version
                ).length
            "
            variant="warning"
            size="sm"
            class="float-right"
            @click="downloadReport()"
          >
            Шинэчлэлт татах
          </b-button>
          <b-button
            v-else-if="
              downloadedRdy &&
                downloadedReports.filter(x => x.mainReportId == store.task.id)
                  .length == 0
            "
            variant="success"
            size="sm"
            class="float-right"
            @click="downloadReport()"
          >
            Татах
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

import { Tree } from "element-ui";

var LTT = require("list-to-tree");
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    Tree,
    reportDialog: () => ({
      component: import("@/views/modules/report/dialog"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    projectUsers: () => ({
      component: import("@/components/project/users.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    store: {
      task: {},
      modal: false
    },
    ot: -1,
    project: {
      id: -1
    },
    tasks: [],
    filterModel: {},
    nowDate: "",
    tasksCount: 0,
    loading: false,
    fetched: false,
    scrHeight: 0,
    scrSideHeight: 0,
    pager: {
      perPage: 50,
      current: 1
    },
    reportDialog: {
      show: false,
      id: 0,
      key: 0,
      obj: {}
    },

    projectEdit: {
      id: 0,
      redner: false,
      show: false,
      mode: 0
    },
    projectMention: {
      show: false
    },

    folders: [],
    foldersFlat: [],
    treeKey: 0,
    expandKeys: [],
    defaultProps: {
      children: "children",
      label: "title",
      iid: "id"
    },
    downloadedReports: [],
    downloadedRdy: false
  }),
  mounted() {
    require("@/assets/scss/pages/filemgr.scss");
    this.build(this.$route.params.ot);
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    build(ot) {
      this.ot = parseInt(ot, 10);
      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == this.ot
      );
      if (prjs != undefined && prjs.length) {
        this.project = prjs[0];
        this.tasks = [];
        this.init(true);
        //this.initFileds();
        this.initSearch();
      } else if (this.ot == 450) {
        this.tasks = [];
        this.init(true, this.ot);
        //this.initSearch();
      } else {
        this.$router.push({ name: "notfound" });
      }
    },
    initSearch() {
      request({
        api: { method: "GET", url: "Type/GetTreeData" },
        params: { parentId: 0, key: "sysRptMainType" },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.foldersFlat = _.orderBy(res.data.types, "ord", "asc");
          var ltt = new LTT(_.orderBy(res.data.types, "ord", "asc"), {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.folders = _.orderBy(ltt.GetTree(), "ord", "asc");
          this.$nextTick(() => {
            this.setExpand();
          });
        }
      });
    },
    init(force, forceOt) {
      this.loading = true;
      if (force) {
        this.filterModel = { task: "" };
        this.pager.current = 1;
      }

      let _data = {
        projectId: this.project.id,
        size: this.pager.perPage,
        skip: (this.pager.current - 1) * this.pager.perPage,
        model: this.filterModel
      };

      if (forceOt != undefined && forceOt == 450) {
        this.filterModel.isGlobal = true;
        _data = {
          size: this.pager.perPage,
          skip: (this.pager.current - 1) * this.pager.perPage,
          ot: forceOt,
          model: this.filterModel
        };
      }

      request({
        api: { url: "taskCore/getCoreList", method: "post" },
        data: _data,
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.handleLoading({ isLoading: false });
          this.nowDate = res.data.nowDate;
          this.tasksCount = res.data.allCount;
          this.tasks = res.data.tasks;
          this.loading = false;
          this.fetched = true;
          if (this.ot == 450) {
            this.initAfter();
          }

          this.$emit("on-fetched");
          this.$nextTick(function() {
            window.addEventListener("resize", this.getWindowHeight);
            this.getWindowHeight();
          });
        } else {
          this.handleLoading({ isLoading: false });
        }
      });
    },
    initAfter() {
      console.log('fomr reports');
      this.downloadedRdy = false;
      this.$nextTick(() => {
        request({
          api: { url: "Report/DownloadedReports", method: "GET" },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.downloadedReports = res.data.list;
            this.downloadedRdy = true;
            //console.log(res);
          }
        });
      });
    },
    showStore(task) {
      this.store.task = task;
      this.store.modal = true;
      //console.log('showStore', task);
    },
    showReport(task) {
      if (this.ot == 450) {
        this.showStore(task);
      } else {
        if (!this.$store.state.app.aside.minimize)
          this.handleAside({ minimize: true, maximize: false });

        this.reportDialog.id = 0;
        this.$nextTick(function() {
          //this.handleLoading({ isLoading: true });
          this.reportDialog.obj = task;
          this.reportDialog.id = task.id;
        });
      }
    },
    getWindowHeight() {
      if (this.reportDialog.id == 0) {
        let extras = 0;
        //this.$refs.mainHeader.offsetHeight +
        //this.$refs.listHeader.offsetHeight +
        //this.$refs.listFooter.offsetHeight;
        let extraSide = 0;
        //this.$refs.mainHeader.offsetHeight +
        //(this.listSetting.statisticLoad?this.$refs.sideTop.offsetHeight:0 )+
        //this.$refs.sideBtm.offsetHeight;
        this.scrHeight = window.innerHeight - extras;
        this.scrSideHeight = window.innerHeight - extraSide;
      }
    },
    reportLoaded() {
      //console.log("taskLoaded", e);
      this.handleLoading({ isLoading: false });
      this.reportDialog.show = true;
    },

    projectUsers() {
      this.projectEdit.render = true;
      this.$nextTick(function() {
        this.projectEdit.show = true;
      });
    },
    projectUsersClosed() {
      this.projectEdit.show = false;
    },
    showMention() {
      this.projectEdit.show = false;
      this.projectMention.show = true;
    },

    //# NODE SECTION
    filterNode(e) {},
    categoryChange(e) {},
    setExpand() {
      // let me = this.foldersFlat.filter(x=>x.id == this.$route.params.cid);
      // if(me.length>0)
      // {
      //   let parent = this.foldersFlat.filter(x=>x.id == me[0].parentId)
      //   this.expandKeys=[];
      //   this.$nextTick(()=>{
      //     if(parent.length>0)
      //       this.expandKeys=[parent[0].id, me[0].id];
      //     else
      //       this.expandKeys=[me[0].id];
      //   });
      // }
    },
    downloadReport() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      //this.handleLoading({ isLoading: false });
      request({
        api: { url: "Report/DownloadReport", method: "post" },
        data: { id: this.store.task.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //this.handleLoading({ isLoading: false });
        if (res != false) {
          this.$bvToast.toast(
            "Амжилттай татлаа. Татсан тайлангууд цэснээс тайлангаа харна уу",
            {
              title: "Мэдэгдэл",
              autoHideDelay: 10000,
              appendToast: true
            }
          );
          this.store.modal = false;
          this.initAfter();
        } else {
          this.store.modal = false;
          this.initAfter();
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute) {
      //console.log(newRoute);
      Object.assign(this.$data, this.$options.data());
      this.build(newRoute.params.ot);
    }
  }
};
</script>
